var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PlantDetailForm',{attrs:{"mode":"update","data":_vm.getItem},on:{"submit":_vm.onSubmit,"abort":_vm.onAbort}}),_c('b-loading',{attrs:{"is-full-page":true,"active":_vm.isLoading,"can-cancel":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }